import { render } from "./DefaultLetter.vue?vue&type=template&id=158dcf4c"
import script from "./DefaultLetter.vue?vue&type=script&lang=js"
export * from "./DefaultLetter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__